import { Dispatch, SetStateAction } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ControlModeInternal, SourceThresholdInternal } from '../../../../../../../data-access/gql-types/graphql';

export enum ThresholdCondition {
  LesserThan = 'LESSER_THAN',
  GreaterThan = 'GREATER_THAN',
}

export type EventingRuleBody = {
  enabled: boolean;
  controlMode: ControlModeInternal;

  source: SourceThresholdInternal;
  deadTimeInMs: string;
  hysteresis: number;
  thresholdCondition: ThresholdCondition | null;
  minValue: number | null;
  maxValue: number | null;

  minPrice: string;
  maxPrice: string;
  startAt: string;
  endAt: string;
  cheapestPeriods: string;
  minPriceChecked: boolean;
  maxPriceChecked: boolean;
  cheapestPeriodsChecked: boolean;

  isDefaultAction: boolean;
  isNotifyAction: boolean;
};

export type MeterConfigurationBody = {
  rules: EventingRuleBody[];
};

export type MeterConfigurationServerError = Record<number, Record<keyof EventingRuleBody, { message: string }>>;

export type MeterConfigurationState = {
  form: UseFormReturn<MeterConfigurationBody, any, MeterConfigurationBody>;
  formValues: MeterConfigurationBody;
  activeRuleIndex: number;
  setActiveRuleIndex: Dispatch<SetStateAction<number>>;
  serverErrors: MeterConfigurationServerError;
  setServerErrors: Dispatch<SetStateAction<MeterConfigurationServerError>>;
  clearServerErrors: () => void;
};

export type RuleError = {
  ErrorCode: string;
  ErrorMessage: string;
  FormattedMessagePlaceholderValues: {
    PropertyPath: string;
    CollectionIndex: number;
    PropertyValue: number;
    From?: number;
    To?: number;
    ComparisonValue?: number;
  };
};

export enum SourceThresholdComponentType {
  Input = 'INPUT',
  Slider = 'SLIDER',
}
